import type { GrupoLembradoLogin } from "../../../../tiposAutenticacaoJwt";
import type { ContextoGrupoLogin } from "../loginUnificado.types";

// ------------------------------- FUNCTIONS -------------------------------
export function resolverIdGrupoConsultaSpace(codigo: string): string | null {
	if (!/^1\d{3}$/.test(codigo)) return null;
	const id = Number(codigo.slice(1));
	return id > 0 ? String(id) : null;
}

export function obterContextoGrupoLogin(
	slug: string | undefined,
	lembrado: GrupoLembradoLogin | null,
): ContextoGrupoLogin {
	if (slug) {
		const mesmoLink = lembrado?.identificacao.tipo === "slug" && lembrado.identificacao.valor === slug;
		return {
			origem: mesmoLink ? "lembrado" : "link",
			identificacao: { tipo: "slug", valor: slug },
			idConsultaSpace: null,
			nome: mesmoLink ? lembrado.grupo.nome : null,
		};
	}

	if (lembrado)
		return {
			origem: "lembrado",
			identificacao: lembrado.identificacao,
			nome: lembrado.grupo.nome,
			idConsultaSpace: lembrado.identificacao.tipo === "codigo" ? String(lembrado.grupo.id) : null,
		};

	return { origem: "codigo", identificacao: null, nome: null, idConsultaSpace: null };
}
